import React from 'react';
import {useTranslation} from 'react-i18next';
import '../component.css';

export default function Blender(props) {
    const {t} = useTranslation();
    return (
        <div className="Container Col">
            <div className="ComponentTitle">{t('blender.title')}</div>
            <div style={{margin: "0.2em 0"}}>
                <div className={"ListItem " + (props.strokeSettings.b === undefined ? "SelectedItem" : "")} onClick={() => props.setStrokeSettings({...props.strokeSettings, b: undefined})}>{t('blender.normal')}</div>
                <div className={"ListItem " + (props.strokeSettings.b === 1 ? "SelectedItem" : "")}  onClick={() => props.setStrokeSettings({...props.strokeSettings, b: 1})}>{t('blender.behindContent')}</div>
                <div className={"ListItem " + (props.strokeSettings.b === 2 ? "SelectedItem" : "")}  onClick={() => props.setStrokeSettings({...props.strokeSettings, b: 2})}>{t('blender.onlyOnContent')}</div>
                </div>
        </div>
    )
}

/*<div className={"ListItem " + (props.strokeSettings.b === 3 ? "SelectedItem" : "")}  onClick={() => props.setStrokeSettings({...props.strokeSettings, b: 3})}>Soft light</div>
            */